import * as paths from 'constants/paths';

const pageMapping = {
  [paths.ABOUT_YOUR_APPLICATION]: 'loan type',
  [paths.ABOUT_YOUR_LOAN_INFO]: 'review loan application',
  [paths.ACCOUNT_LIST_SCREEN]: 'account selection',
  [paths.BEFORE_YOUR_SCREEN]: 'before you continue',
  [paths.BEFORE_YOUR_SCREEN]: 'redirect to existing',
  [paths.CHECKING_YOUR_IDENTITY]: 'id&v begin screen',
  [paths.CHOOSE_A_USERNAME]: 'save your application',
  [paths.CONFIRM_AUTH_CODE]: '3d auth failed screen',
  [paths.CONFIRM_CODE]: '3d auth screen',
  [paths.CONFIRM_JOINT_LINK_CODE]: 'link code screen',
  [paths.CONGRATULATIONS]: 'congratulations - the loan is yours',
  [paths.CREDIT_CARD_DETAILS]: 'additional information',
  [paths.CREDIT_CHECK_DECLINE]: 'declined screen',
  [paths.CREDIT_CHECK_REFERRED_BANK_CHECK_POI]: 'common refer screen',
  [paths.CREDIT_CHECK_REFERRED_BANK_CHECK]: 'common refer screen',
  [paths.CREDIT_CHECK_REFERRED_NO_MATCH]: 'common refer screen',
  [paths.CREDIT_CHECK_REFERRED_POI]: 'common refer screen',
  [paths.CREDIT_CHECK_REFERRED_POI]: 'proof of income screen',
  [paths.CREDIT_CHECK_REFERRED]: 'need time to review screen',
  [paths.DIRECT_DEBIT_INSTRUCTIONS]: 'direct debit screen',
  [paths.DOCUMENTS_ON_WAY]: 'loan agreement screen',
  [paths.DOCUMENT_RECEIVED]: 'documents on your way',
  [paths.EMPLOYMENT_DETAILS]: 'employment details',
  [paths.ERROR]: 'error page',
  // [paths.EXIT]: 'exit application',
  [paths.GET_IN_TOUCH]: 'get in touch',
  [paths.ID_CHECK_CAN_NOT_DONE]: 'id required screen',
  [paths.INCOME_AND_EXPENSES]: 'income & expenses',
  [paths.INELIGIBILTY_SCREEN]: 'ineligibility',
  [paths.INELIGIBILTY_SCREEN]: "can't continue screen",
  [paths.INFORM_CHOICE]: 'personal loans',
  [paths.INFORMATION_ABOUT_YOUR_LOAN]: 'review loan application', //ABOUT_YOUR_LOAN_INFO
  [paths.CONSOLIDATE_YOUR_DEBT]: 'external debt consolidation screen',
  [paths.INTERNAL_DEBT_CONSOLIDATE]: 'internal debt consolidation screen',
  [paths.JOINT_APPLICATION_SUBMISSION]: 'application submitted', //  SUBMISSION_HOLDING_SCREEN
  [paths.JOINT_INITIAL_QUESTION]: 'joint initial questions',
  [paths.JOINT_BEFORE_YOUR_SCREEN]: 'joint before you continue screen',
  [paths.MARKETING_PREFERENCES]: 'marketing_consent',
  [paths.REVIEW_YOUR_DETAILS]: 'review application',
  [paths.REVIEW_YOUR_LOAN_DETAILS]: 'review your details',
  [paths.ROOT]: 'pre eligibility question',
  [paths.SOLE_INITIAL_QUESTIONS]: 'ask eligibility screen',
  [paths.SUBMISSION_HOLDING_SCREEN]: 'application holding screen', // screen is same based on condition content will display
  [paths.USE_OF_PERSONAL_INFORMATION]: 'personal info screen',
  [paths.VERIFYING_YOUR_IDENTITY]: 'id&v questions screen',
  [paths.YOUR_ADDRESS_DETAILS]: 'address details',
  [paths.YOUR_CHANGING_FINANCIAL_CIRCUMSTANCES]: 'change in circumstances',
  [paths.YOUR_CONTACT_DETAILS]: 'contact details',
  [paths.YOUR_EMPLOYMENT_DETAILS]: 'employment details - customer info',
  [paths.YOUR_FINANCIAL_CIRCUMSTANCES]: 'are your financial circumstances likely to change?',
  [paths.YOUR_LOAN_AGREEMENT]: 'loan approved screen',
  [paths.YOUR_LOAN_AGREEMENT]: 'review offer',
  [paths.YOUR_LOAN_APPROVAL]: 'change of loan details', // LoanApprovalModal  - this is modal popup
  [paths.YOUR_LOAN_APPROVAL]: 'offer',
  [paths.YOUR_LOAN_OPTIONS]: 'loan calculator',
  [paths.YOUR_LOAN_PURPOSE]: 'what do you want to use the loan for?',
  [paths.YOUR_MAIN_BANK_ACCOUNT]: 'select main account',
  [paths.YOUR_PERSONAL_DETAILS]: 'personal details',
  [paths.YOUR_SIGNATURE_IS_NEEDED]: 'pre contract screen'
};

export function getPageName(path) {
  return pageMapping[path] ? `personal loans application|${pageMapping[path]}` : '';
}
